import { Dialog } from '@mui/material';
/** @jsxImportSource @emotion/react */
import styled from '@emotion/styled';

export const StyledDialog = styled(Dialog)`
  .MuiPaper-root {
    border-radius: 12px;
  }
`;
